<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-xm(:title="$t('mantra')")
    .grid.is-widescreen-8.is-desktop-10
      .column
        p.u-text-lg {{$t('mantraDesc')}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec1')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md.u-mb-md
    AppLink(to="/contact" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Code talks",
    "pageDesc":"Code talks is Baianat event for developers where they get to know more about the latest technologies and meet with peers. ",
    "mantra":"Share knowledge with |other enthusiast |developers.",
    "mantraDesc":"Code talks brings developers from around the MENA region for an intensive sessions and workshops that tackle every aspect of development. From logic, to technology challenges, we make sure you enjoy your time and go home with many perspectives.",
    "sec1":"Aligned sessions.",
    "sec1Items":{
      "1":{
        "title":"Frontend track",
        "desc":"Join the frontend geeks community and discover the potential in different technologies through in depth technical conversations."
      },
      "2":{
        "title":"Backend track",
        "desc":"Enjoy conversations that ignite problem solving skills and introduces you to the deepest parts of the technology used."
      }
    },
    "sec2":"What to expect?",
    "sec2Items":{
      "1":{
        "title":"International speakers",
        "desc":"For an insane experience that levels up to your expectations, we make are bringing the best in the field to share their knowledge and adventures."
      },
      "2":{
        "title":"Technology focused",
        "desc":"Enjoy technology specific tracks where you can delve into the most advanced techniques related to your stack."
      },
      "3":{
        "title":"In close sessions",
        "desc":"Meet Baianat development team and speakers and get into bonding conversations about various topics."
      },
      "4":{
        "title":"Product launch",
        "desc":"Whether open source or premium, get your hands first on our latest products and discover the thinking process behind."
      }
    },
    "cta":"Join our <br> code talks!"
  },
  "ar": {
    "pageTitle":"مناقشات البرمجة",
    "pageDesc":"مناقشات البرمجة هو أحد فعاليات بيانات للمطورين من أجل أن يتعرفوا على المزيد حول أحدث التقنيات البرمجية ويتعرفون على أصدقائهم في المجال.",
    "mantra":"تبادل المزيد من |المعرفة حول البرمجة.",
    "mantraDesc":"مناقشات البرمجة أحد فعاليات بيانات تهدف إلى إنشاء تجمع بين المبرمجين من جميع أنحاء منطقة الشرق الأوسط وشمال أفريقيا، من أجل حضور جلسات وورش عمل مكثفة تتناول كل جانب من جوانب البرمجة. بداية من المنطق حتى تحديات التكنولوجيا، نحرص في كل لحظة على الاستمتاع بوقتك والعودة إلى منزلك محملًا بالعديد من وجهات النظر. ",
    "sec1":"جلسات موازية",
    "sec1Items":{
      "1":{
        "title":"مسار برمجة الواجهة الأمامية",
        "desc":"انضم إلى فريق من الشغوفين ببرمجة الواجهة الأمامية واكتشف التقنيات المختلفة من خلال محادثات تقنية أكثرعمقًا."
      },
      "2":{
        "title":"مسار برمجة الواجهة الخلفية",
        "desc":"استمتع بالمحادثات التي تزيد من شغفك نحو حل المشكلات وتعمق أكثر في التكنولوجيا المستخدمة في البرمجة."
      }
    },
    "sec2":"ماذا تتوقع؟",
    "sec2Items":{
      "1":{
        "title":"متحدثون دوليون",
        "desc":"من أجل تجربة متميزة تناسب مستوى توقعاتك، ندعو أفضل المحاضرين في هذا المجال من أجل تبادل المزيد من المعارف والخبرات."
      },
      "2":{
        "title":"التركيز على التكنولوجيا",
        "desc":"تمتع بالمسارات الخاصة بالتكنولوجيا حيث يمكنك التعمق في التقنيات الأكثر تقدمًا والمتعلقة بما تقوم به."
      },
      "3":{
        "title":"جلسات مغلقة.",
        "desc":"تعرف على فريق البرمجة الخاص ببيانات والمتحدثين وتناقش حول مختلف الموضوعات."
      },
      "4":{
        "title":"إطلاق المنتج",
        "desc":"سواء كان مصدرًا مفتوحًا أو استثنائي، تعرف على أحدث منتجاتنا واكتشف عملية التفكير وراء كل منتج."
      }
    },
    "cta":"انضم إلى مناقشات <br> البرمجة الخاصة بنا!"
  }
}
</i18n>
